<!--
 * @FileDescription: 异常订单详情
 * @Author: 陈文景
 * @Date: 2022-11-14 10:54:59
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="container">
    <div class="reason">
      <h3>异常原因</h3>
      <div class="content">
        {{ defaultTips(details.causesFailure) }}
      </div>
    </div>

    <div class="details">
      <div class="list">
        <h3 class="title">商品信息</h3>
        <div>
          <template v-if="items.length">
            <SkuInfoItemThree v-for="(item, index) in items" :key="index" :data="item" />
          </template>
          <el-empty v-else />
        </div>
      </div>

      <div class="info">
        <div class="top">
          <div class="amount-info">
            <p>
              <span>平台状态</span>
              <span class="special">{{ defaultTips(details.financialStatus) }}</span>
            </p>
            <p>
              <span>下单时间</span>
              <span class="special">{{ defaultTips(formatTimeStamp(details.purchaseDate)) }}</span>
            </p>
            <p>
              <span>付款时间</span>
              <span class="special">{{ defaultTips(formatTimeStamp(details.payDate)) }}</span>
            </p>
            <p>
              <span>抓单时间</span>
              <span class="special">{{ defaultTips(formatTimeStamp(details.createDate)) }}</span>
            </p>
            <p>
              <span>付款方式</span>
              <span class="special">{{ defaultTips(details.paymentMethod) }}</span>
            </p>
            <p>
              <span>收款交易号</span>
              <span class="special">{{ defaultTips(details.paymentOrder) }}</span>
            </p>
            <p>
              <span>订单总金额</span>
              <span class="special">{{ `$${defaultTips(details.totalAmount)}` }}</span>
            </p>
          </div>
        </div>

        <div class="button">
          <h3 class="title">Shipping Address</h3>
          <div class="addres">
            <p>{{ address.country }}</p>
            <p>{{ address.city }}</p>
            <p>{{ address.phone }}</p>
            <p>{{ address.recipient }}</p>
            <p>{{ address.street1 }}</p>
            <p>{{ address.street2 }}</p>
            <p>{{ address.province }}</p>
            <p>{{ address.zip }}</p>
            <p>{{ address.vat }}</p>
            <p>{{ address.ioss }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import SkuInfoItemThree from '@/components/SkuInfoItemThree.vue'
import { formatTimeStamp } from '@/utils/moment.js'

export default {
  components: {
    SkuInfoItemThree
  },
  data() {
    return {
      formatTimeStamp,

      details: {},

      address: {},

      items: []
    }
  },
  mounted() {
    this.getAnomalousOrderDetails()
  },
  computed: {
    defaultTips() {
      return (value) => value || '-'
    }
  },
  methods: {
    async getAnomalousOrderDetails() {
      let { data } = await API.getAnomalousOrderDetails(this.$route.query.id, this.$route.query.platformCode)
      this.details = data
      this.items = data.items
      this.address = data.address
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1280px;
  margin: 0 auto;

  .reason {
    padding: 20px;
    background-color: #fff;
    h3 {
      font-size: 16px;
      font-weight: 500;
    }
    .content {
      color: #eb5757;
      padding: 20px 0;
    }
  }

  .details {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    .list {
      flex: 1;
      padding: 20px;
      background-color: #fff;
      .title {
        font-size: 16px;
        font-weight: 500;
      }
    }

    .info {
      width: 368px;
      margin-left: 10px;
      .top {
        width: 100%;
        .amount-info {
          padding: 20px;
          background-color: #fff;
          border-bottom: 1px solid #f5f7f7;
          p {
            display: flex;
            color: #747a87;
            font-size: 14px;
            font-weight: 500;
            margin-top: 20px;
            justify-content: space-between;
            &:first-child {
              margin-top: 0;
            }
            .special {
              color: #10141d;
              font-size: 16px;
              font-weight: 500;
            }
          }
        }
      }
      .button {
        width: 100%;
        margin-top: 10px;
        padding: 20px;
        background-color: #fff;
        .title {
          font-size: 16px;
          font-weight: 500;
        }
        .addres {
          color: #8b93a3;
          font-size: 14px;
          line-height: 28px;
          margin-top: 15px;
        }
      }
    }
  }
}
</style>
